<template>
	<div @click="upload">
		<slot/>
	</div>
</template>
<script>
export default  {
	  data(){
			return {passwordShown:false}
		},
		mounted() {
			let input=document.createElement("input");
			input.type=file;
			input.addElementListner("change",(e)=>{
				
			})
		},
		computed: {
			upload(){
				input.click();
			}
		}
	};
</script>
<style scoped>

</style>